const gridProfile = {
  gridProfile: {
    pageHeader: 'Netzprofil',
    name: 'Name',
    description: 'Beschreibung',
    createdBy: 'Erstellt von',
    noGrid: '** Keine Netze verfügbar **',
    grids: 'Netze'
  }
};

export default gridProfile;
